import api from "../../../api/kpis/equipments.js";

import _ from "lodash";

const namespaced = true;

const state = {
    data_equipment: [],
    loading : false,
   
};
const mutations = {
    SET_DATA_EQUIPMENT(state, data) {
        state.data_equipment = data;
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    
};
const actions = {
    getKpisEquipment(context,data) {
        return new Promise((resolve) => {
            context.commit("SET_LOADING", true);
            api.getKpisEquipment(data)
                .then(function (res) {
                    context.commit("SET_DATA_EQUIPMENT", res.data.data);
                    context.commit("SET_LOADING", false);
                    resolve(res.data);
                })
                .catch(function (error) {
                    context.commit("SET_LOADING", false);
                    console.log(error);
                });
        });
    },
};

const getters = {
    getEquipmentByArea(state){
        return (state.data_equipment.length>0)?_.groupBy(state.data_equipment , 'area_id'):[];
    },
    getKpiExport(state) {
        let transformData = _.map(state.data_equipment, (item) => [
            item.area,
            item.sub_production_area,
            item.name,
            item.tiempo_disponible_por_dias,
            item.tiempo_demora_programada,
            item.cantidad_demora_programada,
            item.tiempo_demora_no_programada,
            item.cantidad_demora_no_programada,
            item.tiempo_disponible_quitando_programado,
            item.porcentaje_disponible_quitando_programado,
            item.tiempo_disponible_quitando_demora_programada_demora_no_programada,
            item.porcentaje_disponible_quitando_demora_programada_demora_no_progr,
           
        ]);
        return transformData;
    },
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
};
